var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailUnread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.5 7.046a2 2 0 012-2h17a2 2 0 012 2v10.609a2 2 0 01-2 2h-17a2 2 0 01-2-2V7.045z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.962 5.577L12 13.72 2.038 5.577",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS41IDcuMDQ1OUMxLjUgNS45NDEzMyAyLjM5NTQzIDUuMDQ1OSAzLjUgNS4wNDU5SDIwLjVDMjEuNjA0NiA1LjA0NTkgMjIuNSA1Ljk0MTMzIDIyLjUgNy4wNDU5VjE3LjY1NDZDMjIuNSAxOC43NTkyIDIxLjYwNDYgMTkuNjU0NiAyMC41IDE5LjY1NDZIMy41QzIuMzk1NDMgMTkuNjU0NiAxLjUgMTguNzU5MiAxLjUgMTcuNjU0NlY3LjA0NTlaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIxLjk2MjIgNS41NzcyN0wxMiAxMy43MTk4TDIuMDM3NzggNS41NzcyNyIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgEmailUnread as ReactComponent };